import axiosInstance from "@/api/axiosInstance";
import {
  SearchEventSessionsRequest,
  SearchEventSessionsResponse,
} from "./types";

export const searchEventSessions = async (
  request: SearchEventSessionsRequest = {},
): Promise<SearchEventSessionsResponse> => {
  const params: Record<string, string | number> = {};
  if (request.q !== undefined && request.q !== "") params.q = request.q;
  if (request.limit !== undefined) params.limit = request.limit;
  if (request.offset !== undefined) params.offset = request.offset;

  const response = await axiosInstance.get<SearchEventSessionsResponse>(
    "/api/private/event-sessions/search",
    { params },
  );

  return response.data;
};
